import { fwUtil } from "../../focuswin/script/util";
import { mesGubu } from "../set";

const getPlanOrdeList = async (sendData) => {
    try {
        const api = `privat${mesGubu}/set/mfg/plan/register/order/list`;
        const data = await fwUtil.apis.search(api, sendData);

        return data;
    }
    catch (error) {
        console.log('getPlanOrdeList.error === ', error);
        return [];
    }
};

const getPlanItemList = async (sendData) => {
    try {
        const api = `privat${mesGubu}/set/mfg/plan/register/itemcode/list`;
        const data = await fwUtil.apis.search(api, sendData);

        return data;
    }
    catch (error) {
        console.log('getPlanItemList.error === ', error);
        return [];
    }
};

const getWorkClieList = async (sendData) => {
    try {
        const api = `privat${mesGubu}/set/mfg/work/order/register/client/list`;
        const data = await fwUtil.apis.search(api, sendData);
        return data;
    }
    catch (error) {
        console.log('getWorkClieList.error === ', error);
        return [];
    }
};

const getWorkPlanList = async (sendData) => {
    try {
        const api = `privat${mesGubu}/set/mfg/work/item/register/plan/list`;
        const data = await fwUtil.apis.search(api, sendData);

        return data;
    }
    catch (error) {
        console.log('getWorkPlanList.error === ', error);
        return [];
    }
};

const getWorkItemList = async (sendData) => {
    try {
        const api = `privat${mesGubu}/set/mfg/work/item/register/item/list`;
        const data = await fwUtil.apis.search(api, sendData);

        return data;
    }
    catch (error) {
        console.log('getWorkItemList.error === ', error);
        return [];
    }
};

const getWorkRoutInfoList = async (sendData) => {
    try {
        const api = `privat${mesGubu}/set/mfg/work/rout/register/rout/list`;
        const data = await fwUtil.apis.search(api, sendData);

        return data;
    }
    catch (error) {
        console.log('getWorkRoutInfoList.error === ', error);
        return [];
    }
};

const getWorkRoutGubuList = async () => {
    try {
        const api = `privat${mesGubu}/set/mfg/work/rout/register/gubu/list`;
        const data = await fwUtil.apis.search(api);
        let convData = [];
        if (data && data.length > 0) {
            convData = data.map(item => item.subs_name);
        }
        return convData; 
    }
    catch (error) {
        console.log('getWorkRoutGubuList.error === ', error);
        return [];
    }
};

const getProdRoutList = async (sendData) => {
    try {
        const api = `privat${mesGubu}/set/mfg/prod/register/routnumb/list`;
        const data = await fwUtil.apis.search(api, sendData);

        return data;
    }
    catch (error) {
        console.log('getProdRoutList.error === ', error);
        return [];
    }
};

const getProdEquiList = async (sendData) => {
    try {
        const api = `privat${mesGubu}/set/mfg/prod/register/equinumb/list`;
        const data = await fwUtil.apis.search(api, sendData);
        
        return data;
    }
    catch (error) {
        console.log('getProdEquiList.error === ', error);
        return [];
    }
};

const getProdNameList = async () => {
    try {
        //const api = `privat${mesGubu}/undefined`;
        //const data = await fwUtil.apis.search(api);
        const data = ["홍길동 [CS120001]", "김철수 [CS120002]", "차연정 [CS120003]", "반기문 [CS120004]",];
        return data;
    }
    catch (error) {
        console.log('getPosiList.error === ', error);
        return [];
    }
};

const getYardItemGubu = async () => {
    try {
        const api = `privat${mesGubu}/set/mfg/yard/status/itemgubu/list`;
        const data = await fwUtil.apis.search(api);
        return data;
    }
    catch (error) {
        console.log('getYardItemGubu.error === ', error);
        return [];
    }
};

const getProdStocLoca = async () => {
    try {
        const api = `privat${mesGubu}/set/mat/stock/adjustment/stocloca/list`;
        const data = await fwUtil.apis.search(api);
        let convData = [];
        if (data && data.length > 0) {
            convData = [...convData, ...data.map(item => item.subs_name)];
        }
        return convData; 
    }
    catch (error) {
        console.log('getProdStocLoca.error === ', error);
        return [];
    }
};

export const mfg = {
    plan: {
        orde: getPlanOrdeList,
        item: getPlanItemList,
    },
    work: {
        clie: getWorkClieList,
        plan: getWorkPlanList,
        item: getWorkItemList,
        rout: {
            info: getWorkRoutInfoList,
            gubu: getWorkRoutGubuList,
        },
    },
    prod: {
        rout: getProdRoutList,
        equi: getProdEquiList,
        name: getProdNameList,
        stoc: getProdStocLoca,
    },
    yard: {
        item: {
            gubu: getYardItemGubu,
        } 
    },
}